import { render, staticRenderFns } from "./CreateAttributes.vue?vue&type=template&id=2250d9fb&"
import script from "./CreateAttributes.vue?vue&type=script&lang=js&"
export * from "./CreateAttributes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports